module.exports = require("body-parser");


/*****************
 ** WEBPACK FOOTER
 ** external "body-parser"
 ** module id = 6
 ** module chunks = 0
 **/